module.exports = __webpack_public_path__ + "static/media/wheels_logo.1feb6b9d.png";